import moment from 'moment-timezone';
import _ from 'underscore';
export colors from './constants/colors';
export mapPinTypes from './constants/mapPinTypes';
export standardIcons from './constants/icons';
export STATES from './constants/states';
export commonPropTypes from './constants/propTypes';
export contactInfoTypes from './constants/contactInfoTypes';

const UUID_REG_EX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const dateFormats = {
  ISO_8601: 'YYYY-MM-DD',
  DISPLAY_DATE: 'ddd, l',
  DISPLAY_TIME: 'LT',
  MM_DD_YY: 'MM/DD/YY',
  SHORT: 'ddd M/D',
  VALID_DATES: [ 'YYYY-MM-DD', 'MM-DD-YYYY', 'MM-DD-YY' ],
  VALID_TIMES: [ 'HH:mm', 'H:mm', 'hh:mma', 'h:mma', 'hh:mmA', 'h:mmA', 'hh:mm A', 'h:mm A' ]
};

const TIMEZONES = [
  {
    label: 'Eastern',
    value: 'America/New_York'
  },
  {
    label: 'Central',
    value: 'America/Chicago'
  },
  {
    label: 'Mountain',
    value: 'America/Denver'
  },
  {
    label: 'Mountain (Arizona)',
    value: 'America/Phoenix'
  },
  {
    label: 'Pacific',
    value: 'America/Los_Angeles'
  },
  {
    label: 'Alaska',
    value: 'America/Anchorage'
  },
  {
    label: 'Hawaii',
    value: 'America/Adak'
  },
];

const userTimezone = moment.tz.guess();
const DEFAULT_TIMEZONE = (_.find(TIMEZONES, tz => tz.value === userTimezone) || TIMEZONES[ 1 ]).value;

const dateTimes = {
  THIS_YEAR: moment().year()
};

const DEFAULT_PAGE_INFO = { pageNo: 0, pageSize: 20 };

const EMPTY_TABLE_CELL = '-';

const eventTypes = {
  GAME: 'Game',
  SCHOOL_GAME: 'SchoolGame',
  TOURNEY_APPOINTMENT: 'TourneyAppointment',
  RECRUIT_APPOINTMENT: 'RecruitAppointment'
};

const localStorageKeys = {
  FR_TOKEN: 'fr_token',
  LAST_HS_SEASON_SEARCH: 'last_hs_season_search'
};

const requestHeaders = {
  MAX_COUNT_HEADER: 'X-Max-Count',
  TOTAL_RECORDS_COUNT_HEADER: 'X-Total-Records',
  SCROLL_ID: 'x-scroll-id',
  TOTAL_HITS: 'x-total-hits'
};

const keyCodes = {
  // Directions
  KEY_UP: 38,
  KEY_RIGHT: 39,
  KEY_DOWN: 40,
  KEY_LEFT: 37,

  // Other
  KEY_ENTER: 13,
  KEY_TAB: 9,
  KEY_ESCAPE: 27,
  KEY_PAGE_UP: 33,
  KEY_PAGE_DOWN: 34,
  KEY_HOME: 36,
  KEY_END: 35,
  KEY_BACKSPACE: 8,
  KEY_DELETE: 46
};


const sorts = {
  GAMES_DEFAULT: { attribute: 'scheduled', desc: false }
};

const ALL_RECRUITS = 'All Recruits';
const TOP_20 = 'Top 20';

export {
  ALL_RECRUITS,
  dateFormats,
  dateTimes,
  DEFAULT_PAGE_INFO,
  DEFAULT_TIMEZONE,
  EMPTY_TABLE_CELL,
  eventTypes,
  keyCodes,
  localStorageKeys,
  requestHeaders,
  sorts,
  TIMEZONES,
  TOP_20,
  UUID_REG_EX
};




// WEBPACK FOOTER //
// ./src/js/util/constants.js